import React from "react";

import { OverflowTooltip } from "components";
import { getAppStatuses } from "mappers";
import { Application, TableCellProp } from "types";

const applicationStatusColumn = () => ({
	Header: "App Status",
	accessor: "applicationStatus",
	disableSortBy: true,
	Cell: ({ row: { original } }: TableCellProp<Application>) => {
		const appStatus = original?.application_status;
		return (
			<span className={"text-primary cut-text-laptop"}>
				<OverflowTooltip onlyOnLaptop title={getAppStatuses(appStatus)}>
					{getAppStatuses(appStatus)}
				</OverflowTooltip>
			</span>
		);
	},
});

export default applicationStatusColumn;
